import { downloadInvestigationReport } from 'api/bitedb/entities/entityDocuments.service';

/**
 * Downloads the Beneficial Ownership investigation's report PDF. The record's
 * Export menu offers it once the Deep Dive has a report. The server builds it,
 * so it is the same document the run filed to the Library.
 */
export const downloadOwnershipReportPdf = (
  databaseId: string,
  databaseEntityId: string,
  ticketId: string,
): Promise<void> =>
  downloadInvestigationReport(databaseId, databaseEntityId, ticketId);
